export const COLUMN_WIDTH = Object.freeze({
	full: 'full',
	contained: 12,
	thin: 6,
})

export const SM_WIDTH = Object.freeze({
	contained: 12,
	thin: 8,
})
